import { Palette } from 'core/config';
import styled from 'styled-components';

export const ProgressBarHolder = styled.div`
    height: 7px;
    width: 60%;
    background-color: ${Palette.TAN};
    border-radius: 40px;
    margin-top: 15px;
`;

export const Progress = styled.div<{ progress: number }>`
    height: 100%;
    width: ${({ progress }) => progress}%;
    background-color: ${Palette.ORANGE};
    border-radius: 40px;
`;
